/**
 * @generated SignedSource<<b9d4e056088c1bf2c2d59136d01dd4a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PublishState = "ARCHIVED" | "DELETED" | "DRAFT" | "PUBLISHED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FormViewer_node$data = {
  readonly canUpdate?: {
    readonly value: boolean;
  };
  readonly content?: {
    readonly id?: string;
    readonly isClosed?: boolean;
    readonly responses?: {
      readonly totalCount: number;
    };
    readonly " $fragmentSpreads": FragmentRefs<"EditForm_form" | "RespondForm_form">;
  };
  readonly id?: string;
  readonly publishState?: PublishState;
  readonly " $fragmentSpreads": FragmentRefs<"EditForm_folderItem" | "PublishReminderDialog_folderItem" | "RespondForm_folderItem">;
  readonly " $fragmentType": "FormViewer_node";
};
export type FormViewer_node$key = {
  readonly " $data"?: FormViewer_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"FormViewer_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FormViewer_node",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publishState",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RespondForm_folderItem"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EditForm_folderItem"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isClosed",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RespondForm_form"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EditForm_form"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormResponseConnection",
                  "kind": "LinkedField",
                  "name": "responses",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalCount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Form",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PublishReminderDialog_folderItem"
        }
      ],
      "type": "FolderItem",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "f7030dc3b90ee8da845d65ed91f671db";

export default node;
